import React from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';

const Meta = ({ page }) => (
	page !== null ? (
		<Helmet>
			<title>{`${page.Name} | ${document.querySelector('meta[property="og:site_name"]').getAttribute('content')}`}</title>
		</Helmet>
	) : null
);

const mapStateToProps = ({ pageReducer }) => ({
	page: pageReducer.page
});

export default connect(mapStateToProps)(Meta);
